/*
 * @Author: your name
 * @Date: 2021-03-11 09:21:16
 * @LastEditTime: 2021-05-21 10:49:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \zlt-front-end\src\SRM\api\common.js
 */
import request from '../../utils/request'

//登录
export function loginRequest(data) {
    return request({
        url: '/auth/account/login',
        method: 'post',
        data
    })
}

//退出登录
export function logoutRequest(query) {
    return request({
        url: '/auth/account/logout',
        method: 'get',
        params: query
    })
}

//上传图片
export function uploadImg(data) {
    return request({
        url: '/external/uploadFile',
        method: 'post',
        data
    })
}

//图片与视频合成新的视频
export function imgToVideo(data) {
    return request({
        url: '/external/mergePicWithVideo2OssFile',
        method: 'get',
        params:data
    })
}
//存储合成后视频
export function savePosterUrl(data) {
    return request({
        url: '/product/eshop/srm/product/updateProductVideoPosterUrl',
        method: 'post',
        data
    })
}

// 菜单
export function queryMenusByToken(query) {
    return request({
        url: '/auth/menus/queryMenusByToken',
        method: 'get',
        params: query
    })
}


//微信支付
export function WechatPay (params) {
    return request({
        url: '/auth/menus/WechatPay',
        method: 'get',
        params: query
    })
}

// 当前用户信息
export function currentUser(query) {
    return request({
        url: '/auth/account/currentUser',
        method: 'get',
        params: query
    })
}

// 获取行政区域树形结构 不包含街道
export function cityTree(data) {
    return request({
        url: '/resource/basicDomesticArea/tree',
        method: 'post',
        data
    })
}


// 获取行政区域列表
export function areaList(data) {
    return request({
        url: '/resource/basicDomesticArea/list',
        method: 'post',
        data
    })
}

// 根据区域Id获取关联的行政区域
export function getBaseAreaByAreaId(params) {
    return request({
        url: '/resource/basicDomesticArea/getBaseAreaByAreaId',
        method: 'get',
        params
    })
}

//查询当前是否存在区域未设置
// /auth/shopowner/queryIsHasNewArea
export function queryIsHasNewArea() {
    return request({
        url: '/auth/shopowner/queryIsHasNewArea',
        method: 'post',
    })
}

//登陆成功必调接口
export function initSettingBycurrUser() {
    return request({
        url: '/setting/eshop/init/initSettingBycurrUser',
        method: 'get',
    })
}

//查询机构
export function storeList(params) {
    return request({
        url: '/auth/account/storeList',
        method: 'get',
        params
    })
}

//切换机构
export function changeOrg(data) {
    return request({
        url: '/auth/account/changeOrg',
        method: 'post',
        data
    })
}

//获取用户基础信息
export function getBase(data) {
    return request({
        url: '/auth/personal/accountInfo',
        method: 'post',
    })
}

//登陆成功展示协议
export function readAgree(data){
    return request({
        url: '/auth/personal/queryReadAgreement',
        method: 'get',
        params:data
    })
}
//协议确认按钮
export function confirmAgree(data){
    return request({
        url: '/auth/personal/setReadAgreement',
        method: 'get',
        params:data
    })
}


// WEBPACK FOOTER //
// ./src/SRM/api/common.js